export default __webpack_public_path__ + "static/media/159.85487fa3.gif";